import type { Formation } from './types';

/** Shotgun, 3 receivers, back beside the QB. Splits are tight so the formation fits a portrait screen. Seven on the line: five OL, the TE and the split end. */
export const shotgun: Formation = {
  id: 'shotgun',
  name: 'Shotgun',
  side: 'offense',
  slots: [
    { pos: 'OL', x: -3, y: -0.7 },
    { pos: 'OL', x: -1.5, y: -0.7 },
    { pos: 'OL', x: 0, y: -0.7 },
    { pos: 'OL', x: 1.5, y: -0.7 },
    { pos: 'OL', x: 3, y: -0.7 },
    { pos: 'TE', x: 4.6, y: -0.8 },
    { pos: 'WR', x: -12, y: -0.8 },
    { pos: 'WR', x: -6.5, y: -1.6 },
    { pos: 'WR', x: 10, y: -1.6 },
    { pos: 'QB', x: 0, y: -5 },
    { pos: 'RB', x: -1.8, y: -5 },
  ],
};

/** 4-3 base: four down linemen, three backers, two corners on the outside receivers, two deep safeties. */
export const base43: Formation = {
  id: 'base43',
  name: '4-3 Base',
  side: 'defense',
  slots: [
    { pos: 'DL', x: -3.6, y: 1 },
    { pos: 'DL', x: -1, y: 1 },
    { pos: 'DL', x: 1, y: 1 },
    { pos: 'DL', x: 3.6, y: 1 },
    { pos: 'LB', x: -4.5, y: 5 },
    { pos: 'LB', x: 0, y: 5 },
    { pos: 'LB', x: 4.5, y: 5 },
    { pos: 'CB', x: -12, y: 7 },
    { pos: 'CB', x: 10, y: 7 },
    { pos: 'S', x: -6, y: 13 },
    { pos: 'S', x: 6, y: 13 },
  ],
};
